<template>
  <!-- The warnings of the hike a map's card shows (SELECTED-HIKE-ALERTS.md):
       the hike map's round button beside the location control, its sheet,
       the hazard details and the difficult sections, for whichever hike the
       card shows. Another hike starts afresh (keyed by hike); no card, or a
       card for a recording or a planned trail, shows nothing. Sits in a map's
       location slot (MapControls #beside-location) and follows TrailDataCard;
       a page with a card of its own passes its hike instead. -->
  <HikeMapRouteAlerts
    v-if="currentHikeId"
    :key="currentHikeId"
    :hike-id="currentHikeId"
    screen="map_hike_card"
    :report-shown="false"
    :details-screen="detailsScreen"
    :bottom-panel-selector="bottomPanelSelector"
    :dock-selector="dockSelector"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import HikeMapRouteAlerts from './HikeMapRouteAlerts.vue';
import { selectedHikeCard } from '../../utils/routeAlerts/selectedHikeCard';
import { hazardScreen } from '../../utils/trailHazards/hazardAnalytics';

export default defineComponent({
  name: 'SelectedHikeRouteAlerts',
  components: { HikeMapRouteAlerts },
  props: {
    /** The hike, for a page with a card of its own; TrailDataCard's hike otherwise. */
    hikeId: { type: [String, Number], default: undefined },
    /** The card along the bottom of the map that a framed section must clear. */
    bottomPanelSelector: { type: String, default: '.trail-data-card' },
    /** A card down the map's right side that a framed section and the sheet must clear. */
    dockSelector: { type: String, default: null },
  },
  computed: {
    currentHikeId(): string | null {
      if (this.hikeId === undefined) return selectedHikeCard.hikeId;
      return this.hikeId === null || this.hikeId === '' ? null : String(this.hikeId);
    },
    /** Hazard details opened here report the page's own screen, as a marker's do. */
    detailsScreen(): string {
      return hazardScreen();
    },
  },
});
</script>
